<template>
  <div>
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>
import Guest from "./views/components/layouts/Guest";
import Patient from "./views/components/layouts/Patient";
import None from "./views/components/layouts/None";

export default {
  components: {
    'guest-layout': Guest,
    'patient-layout': Patient,
    'none-layout': None,
  },
  computed: {
    layout () {
      return this.$route.meta.layout ?? 'none-layout'
    }
  },
}
</script>

<style>
@import'~bootstrap/dist/css/bootstrap.css';
@import'~@mdi/font/css/materialdesignicons.min.css';
@import'~@iconscout/unicons/css/line.css';
@import "./assets/css/style.css";
@import "./assets/css/colors/default.css";
@import "./assets/css/tokens.css";
@import "./assets/css/theme.css";

.ubbimed-badge {
  position: absolute;
  top: 0px;
  right: 35px;
  background-color: rgba(120, 15, 90, 0.80);
  color: white;
  padding: 5px 10px;
  border-radius: 50%;
  font-size: 12px;
  transform: translate(50%, -50%);
  z-index: 10;
}
</style>
